import { useEffect, useRef, useState } from "react";
import { useFrame } from "@react-three/fiber";
import { api } from "@/lib/api";
import { UserAvatar } from "@/components/clinic/UserAvatar";
import { cafeMe, taken, NameTag, SEATS } from "./CafeAvatar";

export function useCafeSync(user, visible) {
  const [others, setOthers] = useState([]);
  useEffect(() => {
    if (!user) { setOthers([]); return undefined; }
    const tick = () => {
      if (visible) api.post("/cafe/position", { x: cafeMe.x, z: cafeMe.z, yaw: cafeMe.yaw, seat: cafeMe.sit }).catch(() => {});
      api.get("/cafe/avatars").then(({ data }) => {
        taken.clear();
        data.forEach((o) => { if (o.seat) taken.add(o.seat); });
        setOthers(data);
      }).catch(() => {});
    };
    tick();
    const t = setInterval(tick, 2000);
    return () => clearInterval(t);
  }, [user, visible]);
  return others;
}

function Other({ o }) {
  const s = useRef({ x: o.x, z: o.z, yaw: o.yaw, sit: o.seat });
  useFrame((_, dt) => {
    const st = s.current;
    const seat = SEATS[o.seat];
    st.sit = seat ? o.seat : null;
    if (seat) { st.x = seat.x; st.z = seat.z; st.yaw = seat.yaw; return; }
    const k = Math.min(1, dt * 2.5);
    st.x += (o.x - st.x) * k;
    st.z += (o.z - st.z) * k;
    let diff = o.yaw - st.yaw;
    diff = Math.atan2(Math.sin(diff), Math.cos(diff));
    st.yaw += diff * k;
  });
  return (
    <>
      <UserAvatar gender={o.gender} state={s.current} />
      <NameTag state={s.current} name={o.name} color="#7c2d12" />
    </>
  );
}

export function OtherAvatars({ others }) {
  return others.map((o) => <Other key={o.user_id} o={o} />);
}
